







import { computed, defineComponent, PropType } from "@vue/composition-api";
import { isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { isAudioFile, isDocumentFile, isImageFile, isTextFile, isVideoFile } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";

export default defineComponent({
  name: "MessagePreview",
  props: {
    message: { type: Object as PropType<Message>, required: true },
    isOpponentMessage: { type: Boolean, required: true },
  },
  setup(props) {
    const isAttachmentOnly = computed(() => props.message.text.trim() === "" && props.message.attachment);
    const isImage = computed(() => isImageFile(props.message.attachment[0].file));
    const isVideo = computed(() => isVideoFile(props.message.attachment[0].file));
    const isAudio = computed(() => isAudioFile(props.message.attachment[0].file));
    const isDocument = computed(
      () => isTextFile(props.message.attachment[0].file) || isDocumentFile(props.message.attachment[0].file)
    );

    const text = computed(() => {
      const message = props.message;
      const text = message.text.trim();
      if (message.attachment && text === "") {
        if (isImage.value) return $t("Photo");
        if (isVideo.value) return $t("Video");
        if (isAudio.value) return $t("Audio message");
        if (isDocument.value) return $t("Document");
      }
      if (isCallMessageDetails(message.details)) {
        return $t("Call");
      }
      return text;
    });

    return { isAttachmentOnly, text };
  },
});
